// reason: this is the wrapped component which we will allow since this is the exported version
// eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
import { Snackbar as MuiSnackbar, Slide, Stack } from '@mui/material'
import { domAnimation, LazyMotion, m, AnimatePresence } from 'motion/react'
import { SnackbarToast } from './SnackbarToast'
import { type Toast } from './types'

type Props = {
  toasts: Toast[]
}

export const Snackbar = ({ toasts }: Props) => {
  const newToasts = [...toasts]

  if (!toasts || toasts.length === 0) {
    return null
  }

  if (toasts[0]?.position === 'topCenter') {
    newToasts.reverse()
  }

  const variants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        opacity: { duration: 0.2 },
      },
    },
    exit: {
      opacity: 0,
      transition: {
        opacity: { duration: 0.2 },
      },
    },
  }

  return (
    <MuiSnackbar
      data-testid="snackbar-wrapper"
      open
      autoHideDuration={null}
      transitionDuration={0}
      anchorOrigin={
        toasts[0]?.position === 'topCenter'
          ? { horizontal: 'center', vertical: 'top' }
          : { horizontal: 'right', vertical: 'bottom' }
      }
      slots={{
        transition: Slide,
      }}
      sx={{
        mt: 'env(safe-area-inset-top)',
        mb: 'env(safe-area-inset-bottom)',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'column',
          gap: 0.5,
          width: { xs: '100vw', sm: toasts[0]?.width },
          px: 0,
          py: { xs: 1, sm: 0 },
        }}
      >
        <LazyMotion features={domAnimation} strict>
          <AnimatePresence initial={false}>
            {newToasts.map((toast) => (
              <m.div
                key={toast.key}
                layout
                variants={variants}
                initial="initial"
                animate="animate"
                exit="exit"
                style={{ backgroundColor: 'transparent' }}
              >
                <SnackbarToast toast={toast} />
              </m.div>
            ))}
          </AnimatePresence>
        </LazyMotion>
      </Stack>
    </MuiSnackbar>
  )
}
